export { default as WarningModal } from './WarningModal';
export * as Styled from './WarningModal.styles';
